import MicroModal from 'micromodal'
import { clearHash } from '@/scripts/routing/hashCheck'
import interactions from './interactions'
import type { Page } from '@/scripts/data/types'
import audioManager from '@/scripts/audio/audioManager'

function init() {
  try {
    MicroModal.init({
      onShow: (modal) => {
        if (!modal) return
        handleModalShow(modal)
      },
      onClose: (modal) => {
        if (!modal) return
        handleModalClose(modal)
      },
    })
  } catch (err) {
    console.warn('MicroModal init failed:', err)
  }

  initMenuBackButton()
}

function handleModalShow(modal: HTMLElement) {
  if (isMenuModal(modal) || isActivityDetailModal(modal)) {
    interactions.resetPhase()
  }
}

function handleModalClose(modal: HTMLElement) {
  if (isMenuModal(modal)) {
    cleanupMobileIframeMenu()
    clearHash()
  }

  audioManager.setMutedManually(false)
}

function openMobileMenuPage(page: Page) {
  const menu = document.getElementById('modal-menu')
  if (!menu) return

  const container = menu.querySelector<HTMLElement>('.modal__container')
  const iframe = menu.querySelector<HTMLIFrameElement>('#mobile-iframe')
  if (!container || !iframe) return

  container.classList.add('show-iframe')
  iframe.src = extractUrl(page)

  audioManager.setMutedManually(true)

  try {
    MicroModal.show('modal-menu')
  } catch (err) {
    console.warn('MicroModal.show failed:', err)
  }
}

function extractUrl(page: Page): string {
  return page?.url ? String(page.url) : String(page)
}

function initMenuBackButton() {
  const btn = document.querySelector<HTMLButtonElement>('#modal-menu .modal__navigation-back')
  if (!btn) return

  btn.addEventListener('click', (e) => {
    e.preventDefault()
    cleanupMobileIframeMenu()
    clearHash()
  })
}

function cleanupMobileIframeMenu() {
  const menu = document.getElementById('modal-menu')
  if (!menu) return

  const container = menu.querySelector<HTMLElement>('.modal__container')
  const iframe = menu.querySelector<HTMLIFrameElement>('#mobile-iframe')

  container?.classList.remove('show-iframe')
  if (iframe) iframe.src = ''

  audioManager.setMutedManually(false)
}

function isMenuModal(modal: HTMLElement) {
  return modal.id === 'modal-menu'
}

function isActivityDetailModal(modal: HTMLElement) {
  return modal.id === 'modal-activity-detail'
}

export { cleanupMobileIframeMenu }
export default { init, openMobileMenuPage }
